/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import SearchButtonContainer from "containers/search/SearchButtonContainer";
import { SearchUIContainer } from "containers/search/SearchUIContainer";

const SearchWrapperUI = ({ buttonStyle, ...otherProps }) => (
  <Fragment>
    <SearchButtonContainer style={buttonStyle} {...otherProps} />
    <SearchUIContainer {...otherProps} />
  </Fragment>
);

class SearchWrapper extends Component {
  componentDidMount() {
    this.props.onMount();
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  render() {
    const { onMount, onUnmount, ...otherProps } = this.props;
    return <SearchWrapperUI {...otherProps} />;
  }
}

SearchWrapper.propTypes = {
  buttonStyle: PropTypes.object,
  onMount: PropTypes.func,
  onUnmount: PropTypes.func
};

SearchWrapper.defaultProps = {
  buttonStyle: {},
  onMount: () => {},
  onUnmount: () => {}
};

export default SearchWrapper;
